module.exports = __webpack_public_path__ + "img/unsuccess.4408422a.svg";